import { Component, ErrorInfo, ReactNode } from 'react';

interface State {
  error: Error | null;
  componentStack: string | null;
}

export default class CryptoWalletErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null, componentStack: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('CryptoWallet crash:', error, info);
    this.setState({ componentStack: info.componentStack ?? null });
  }

  render() {
    if (this.state.error) {
      const { error, componentStack } = this.state;
      const details = [
        `Message: ${error.message}`,
        error.stack ? `\nStack:\n${error.stack}` : '',
        componentStack ? `\nComponent stack:${componentStack}` : '',
      ].join('');
      return (
        <div className="p-6">
          <div
            className="max-w-2xl rounded p-6"
            style={{ background: 'var(--dash-card)', border: '1px solid var(--dash-border)' }}
          >
            <h2 className="font-sans text-lg font-medium mb-2" style={{ color: 'var(--dash-text-primary)' }}>
              Wallet failed to load
            </h2>
            <p className="font-sans text-sm mb-4" style={{ color: 'var(--dash-text-muted)' }}>
              The crypto wallet module hit an unexpected error. Try refreshing the page.
            </p>
            <pre
              className="font-mono text-[11px] p-3 rounded overflow-auto whitespace-pre-wrap"
              style={{ background: 'var(--dash-input)', border: '1px solid var(--dash-border)', color: 'var(--dash-text-secondary)', maxHeight: '60vh' }}
            >
              {details}
            </pre>
            <button
              onClick={() => { this.setState({ error: null, componentStack: null }); window.location.reload(); }}
              className="mt-4 px-4 py-2 rounded font-mono text-xs uppercase tracking-wider transition-colors"
              style={{ background: 'var(--dash-text-primary)', color: 'var(--dash-bg)' }}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
